import { createStore } from 'vuex'

export default createStore({
    state: {
        // 原有后台系统登录状态（保留不动）
        isLogin: sessionStorage.getItem('isLogin') === 'true' || false,
        isAdmin: sessionStorage.getItem('isAdmin') === 'true' || false,
        token: sessionStorage.getItem('token') || '',
        userInfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),

        // 前台相关（新增 frontUserInfo 存储前台用户信息）
        frontToken: sessionStorage.getItem('web_token') || '', // 前台统一token
        isFrontLogin: !!sessionStorage.getItem('web_token'),   // 是否前台登录（仅通过token判断）
        frontUserInfo: JSON.parse(sessionStorage.getItem('web_frontUserInfo') || '{}'), // 前台用户信息（昵称、头像等）

        // ========= 新增 前台菜单激活index =========
        frontMenuActiveIndex: '/about',

        // 产品表单暂存数据（原有 + 新增）
        productFormData: JSON.parse(sessionStorage.getItem('productFormData') || '{}'),
        productUploadFiles: JSON.parse(sessionStorage.getItem('productUploadFiles') || '{}'),
        // ========== 新增：图片Base64、上传最大索引 ==========
        productImgBase64: JSON.parse(sessionStorage.getItem('productImgBase64') || '{}'),
        productUploadMaxIndex: JSON.parse(sessionStorage.getItem('productUploadMaxIndex') || '{"detail":0,"color":0,"cover":1}'),

        // 新增：存储菜单点击记录（仅title + path，去重）
        menuClickRecords: [],
        // 新增：存储菜单点击记录（仅title + path，去重）基本资料模块
        menuClickRecordss: []
    },
    mutations: {
        //更换头像
        UPDATE_FRONT_AVATAR(state, avatarUrl) {
            state.frontUserInfo = { ...state.frontUserInfo, avatarUrl }
            sessionStorage.setItem('web_frontUserInfo', JSON.stringify(state.frontUserInfo))
        },

        // 原有后台系统mutations（保留不动）
        LOGIN_SUCCESS(state, token) {
            state.isLogin = true
            state.isAdmin = true
            state.token = token
            sessionStorage.setItem('isLogin', 'true')
            sessionStorage.setItem('isAdmin', 'true')
            sessionStorage.setItem('token', token)
        },
        LOGOUT(state) {
            state.isLogin = false
            state.isAdmin = false
            state.token = ''
            state.userInfo = {}
            sessionStorage.removeItem('isLogin')
            sessionStorage.removeItem('isAdmin')
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('userInfo')
        },
        setUserInfo(state, data) {
            state.userInfo = data
            sessionStorage.setItem('userInfo', JSON.stringify(data))
        },

        // 前台登录mutations（完善：新增前台用户信息的存储与清空）
        SET_FRONT_TOKEN(state, token) {
            state.frontToken = token // 仅存储token
            state.isFrontLogin = !!token // 仅通过token判断登录状态
            sessionStorage.setItem('web_token', token)
        },
        // 新增：存储前台用户信息
        SET_FRONT_USER_INFO(state, userInfo) {
            state.frontUserInfo = userInfo
            // 持久化到sessionStorage，防止页面刷新丢失
            sessionStorage.setItem('web_frontUserInfo', JSON.stringify(userInfo))
        },
        // 清空前台登录状态（完善：同时清空前台用户信息）
        CLEAR_FRONT_TOKEN(state) {
            state.frontToken = ''
            state.isFrontLogin = false
            state.frontUserInfo = {} // 清空前台用户信息
            sessionStorage.removeItem('web_token')
            sessionStorage.removeItem('web_frontUserInfo') // 移除持久化的用户信息
        },

        // ===== 新增 mutation 设置前台菜单高亮index =====
        SET_FRONT_MENU_ACTIVE(state, val) {
            state.frontMenuActiveIndex = val
        },

        // ========== 修改产品表单相关mutations ==========
        SAVE_PRODUCT_FORM(state, { formData, uploadFiles, uploadMaxIndex, imgBase64 }) {
            // 1. 基础表单数据
            state.productFormData = { ...formData };
            sessionStorage.setItem('productFormData', JSON.stringify(state.productFormData));

            // 2. 原文件简易信息（保留原有逻辑）
            const serializableFiles = {};
            Object.keys(uploadFiles).forEach(key => {
                if (uploadFiles[key]) {
                    serializableFiles[key] = {
                        name: uploadFiles[key].name,
                        type: uploadFiles[key].type,
                        size: uploadFiles[key].size
                    };
                } else {
                    serializableFiles[key] = null;
                }
            });
            state.productUploadFiles = serializableFiles;
            sessionStorage.setItem('productUploadFiles', JSON.stringify(state.productUploadFiles));

            // 3. 新增：图片Base64
            state.productImgBase64 = { ...imgBase64 };
            sessionStorage.setItem('productImgBase64', JSON.stringify(state.productImgBase64));

            // 4. 新增：上传索引
            state.productUploadMaxIndex = { ...uploadMaxIndex };
            sessionStorage.setItem('productUploadMaxIndex', JSON.stringify(state.productUploadMaxIndex));
        },

        CLEAR_PRODUCT_FORM(state) {
            state.productFormData = {};
            state.productUploadFiles = {};
            state.productImgBase64 = {};
            state.productUploadMaxIndex = { detail: 0, color: 0, cover: 1 };

            // 清空所有表单相关缓存
            sessionStorage.removeItem('productFormData');
            sessionStorage.removeItem('productUploadFiles');
            sessionStorage.removeItem('productImgBase64');
            sessionStorage.removeItem('productUploadMaxIndex');
        },

        // 新增：删除指定的菜单点击记录
        REMOVE_MENU_CLICK_RECORD(state, index) {
            // 根据索引删除对应的记录
            state.menuClickRecords.splice(index, 1);
        },
        // 新增：删除指定的菜单点击记录(基本资料模块)
        REMOVE_MENU_CLICK_RECORDS(state, index) {
            // 根据索引删除对应的记录
            state.menuClickRecordss.splice(index, 1);
        },
        // 新增：添加菜单点击记录（仅title+path，自动去重）
        ADD_MENU_CLICK_RECORD(state, record) {
            // 按path判断是否已存在，不存在则添加
            const isExist = state.menuClickRecords.some(item => item.path === record.path);
            if (!isExist) {
                state.menuClickRecords.push(record);
            }
        },
        // 新增：添加菜单点击记录（仅title+path，自动去重）(基本资料模块)
        ADD_MENU_CLICK_RECORDS(state, record) {
            // 按path判断是否已存在，不存在则添加
            const isExist = state.menuClickRecordss.some(item => item.path === record.path);
            if (!isExist) {
                state.menuClickRecordss.push(record);
            }
        },
        // 可选：清空所有菜单点击记录（按需使用）
        CLEAR_MENU_CLICK_RECORDS(state) {
            state.menuClickRecords = [];
        }
    },
    actions: {
        //更换头像
        updateFrontAvatar({ commit }, avatarUrl) {
            return new Promise((resolve) => {
                commit('UPDATE_FRONT_AVATAR', avatarUrl)
                resolve({ success: true })
            })
        },

        // 原有后台系统actions（保留不动）
        login({ commit }, payload) {
            return new Promise((resolve, reject) => {
                if (payload.access_token) {
                    commit('LOGIN_SUCCESS', payload.access_token)
                    resolve()
                } else {
                    reject(new Error('登录失败：未获取到有效Token'))
                }
            })
        },
        logout({ commit }) {
            commit('LOGOUT')
        },
        async getUserInfo({ commit, state }) {
            try {
                const cachedUserInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
                if (Object.keys(cachedUserInfo).length && !Object.keys(state.userInfo).length) {
                    commit('setUserInfo', cachedUserInfo)
                }
            } catch (error) {
                console.error('恢复用户信息缓存失败：', error)
            }
        },

        // 前台登录相关actions（完善：新增前台用户信息的action）
        frontLogin({ commit }, token) {
            return new Promise((resolve) => {
                commit('SET_FRONT_TOKEN', token)
                resolve({ success: true, token })
            })
        },
        // 新增：专门存储前台用户信息的action（供组件调用）
        setFrontUserInfo({ commit }, userInfo) {
            return new Promise((resolve) => {
                commit('SET_FRONT_USER_INFO', userInfo)
                resolve({ success: true, userInfo })
            })
        },
        // 前台退出登录（无需修改，已在mutation中完善清空用户信息逻辑）
        frontLogout({ commit }) {
            commit('CLEAR_FRONT_TOKEN')
        },

        // ========== 修改暂存Action：接收base64和索引 ==========
        saveProductForm({ commit }, payload) {
            commit('SAVE_PRODUCT_FORM', payload);
        },
        clearProductForm({ commit }) {
            commit('CLEAR_PRODUCT_FORM');
        },

        // 新增：删除菜单点击记录的action
        removeMenuClickRecord({ commit }, index) {
            return new Promise((resolve) => {
                commit('REMOVE_MENU_CLICK_RECORD', index);
                resolve({ success: true });
            });
        },
        // 新增：删除菜单点击记录的action(基本资料)
        removeMenuClickRecordS({ commit }, index) {
            return new Promise((resolve) => {
                commit('REMOVE_MENU_CLICK_RECORDS', index);
                resolve({ success: true });
            });
        },
        // 新增：添加菜单点击记录（供组件调用）
        addMenuClickRecord({ commit }, record) {
            return new Promise((resolve) => {
                commit('ADD_MENU_CLICK_RECORD', record);
                resolve({ success: true, record });
            });
        },
        // 新增：添加菜单点击记录（供组件调用）(基本资料模块)
        addMenuClickRecords({ commit }, record) {
            return new Promise((resolve) => {
                commit('ADD_MENU_CLICK_RECORDS', record);
                resolve({ success: true, record });
            });
        }
    },
    getters: {
        // 原有后台系统getters（保留）
        isAdminLogin: state => state.isLogin && state.isAdmin,
        userInfo: state => state.userInfo,

        // 前台登录相关getters（完善：新增前台用户信息的getter）
        isFrontLogin: state => state.isFrontLogin, // 是否前台登录
        frontToken: state => state.frontToken,     // 前台token
        frontUserInfo: state => state.frontUserInfo, // 前台用户信息（供组件获取）

        // ===== 新增getter 前台菜单高亮 =====
        frontMenuActiveIndex: state => state.frontMenuActiveIndex,

        // 组合判断：是否有任意登录状态（后台/前台）
        isAnyLogin: state => state.isLogin || state.isFrontLogin,

        // 产品表单相关getters（新增base64、索引）
        productFormData: state => state.productFormData,
        productUploadFiles: state => state.productUploadFiles,
        productImgBase64: state => state.productImgBase64,
        productUploadMaxIndex: state => state.productUploadMaxIndex,

        // 新增：获取菜单点击记录
        menuClickRecords: state => state.menuClickRecords,
        // 新增：获取菜单点击记录(基本资料模块)
        menuClickRecordss: state => state.menuClickRecordss,
    }
})